import "reflect-metadata";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import * as filestack from "filestack-js";
import Notifications from "vue-notification";
import Resource from "vue-resource";
// import Filters from './filters'
import "./functions";
import VueMeta from "vue-meta";
import VueCompositionAPI from "@vue/composition-api";
import Vuelidate from "vuelidate";
import money from "v-money";
window.moment = require("moment");
import { BPaginationNav, BTooltip, VBTooltip, BDropdown } from "bootstrap-vue";
import { VMoney } from "v-money";

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./styles/utils.scss";
import "bootstrap/scss/bootstrap-grid.scss";

import "vue-search-select/dist/VueSearchSelect.css";
import "./filters";
Vue.component("b-tooltip", BTooltip);
Vue.directive("b-tooltip", VBTooltip);
Vue.directive("money", VMoney);
Vue.component('b-pagination-nav', BPaginationNav)
Vue.component("b-dropdown", BDropdown);
Vue.use(Resource);
Vue.use(Notifications);
Vue.use(VueMeta);
Vue.use(VueCompositionAPI);
Vue.use(Vuelidate);
Vue.use(money, { precision: 2 });

Vue.config.productionTip = false;

// API ROOT
Vue.http.options.root = process.env.VUE_APP_API_URL;
// window.a = process.env.VUE_APP_FILE_STACK;
// window.client = filestack.init(process.env.VUE_APP_FILE_STACK);
//Vue.http.options.emulateJSON = true;

// API Call interceptor
Vue.http.interceptors.push((request, next) => {
  // generate token
  store.dispatch("fetchApiAuth");
  // Parse the correct content-type depending on the Request URL
  // in the case both of take the same thing
  request.headers.set("Content-Type", "application/json");
  if (store.getters.getApiAuth !== "") {
    request.headers.set("requestId", "");
  }

  if (window.localStorage.getItem("gelato")) {
    request.headers.set(
      "token",
      JSON.parse(window.localStorage.getItem("gelato")).token
    );
  }

  // Middleware for when Access token Expires
  next((response) => {
    if (response.status == 401) {
      window.localStorage.clear();
      router.push({ path: "/login" });

      // Open Session Time out Modal
      // $('#session').modal({
      //     keyboard: false,
      //     backdrop: 'static',
      //     show: true,
      // });
    }
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
